import { RegisterForm } from '@/snippets/account/RegisterForm';

export function Register({ setAction }) {
  return (
    <div>
      <RegisterForm />
    </div>
  );
}
